import { TokenService } from "../../services/TokenService";

const headers = TokenService.getHeaders();
const authorizationBearer = TokenService.getAuthorizationBearer();

export const ResultsAndCommentAPIService =
{
    
    calculateStressResults: async function (periodId, nodeId) {
    let response;
    try {
        response = await fetch(process.env.REACT_APP_LST_API_DOMAIN + '/api/ResultsAndComments/CalculateStressResults/' + periodId + '/' + nodeId, {
            headers: headers
        });
    } catch(error) {
        if (process.env.NODE_ENV === 'development')
            console.log('There was an error', error);
        else
            console.log('There was an error, try again after sometime.');
        response = error
    }

        if(response?.ok) {
        return await response;
    } else {
        if(process.env.NODE_ENV === 'development')
            console.log(`HTTP Response Code: ${response?.status}`)
        return { error: response }
    }
},
    saveNodeVersionComment: async function (comment, periodId, nodeId, nodeVersionCommentId) {
        let response;
        try {
            response = await fetch(process.env.REACT_APP_LST_API_DOMAIN + '/api/ResultsAndComments?comment=' + comment + '&periodId=' + periodId + '&nodeId=' + nodeId + '&nodeVersionCommentId=' + nodeVersionCommentId, {
                method: "POST",
                headers: {
                    Accept: "text/plain",
                    "Content-Type": "application/json",
                    'Authorization': authorizationBearer,
                },
            });

        } catch (error) {
            if (process.env.NODE_ENV === 'development')
                console.log('There was an error', error);
            else
                console.log('There was an error');
            response = error
        }


        if (response?.ok) {
            return true;
        } else {
            if (process.env.NODE_ENV === 'development')
                console.log(`HTTP Response Code: ${response?.status}`)
            return { error: response }
        }
    },

    submitResultAndCommentView: async function (periodId, nodeId) {
        let response;
        try {
            response = await fetch(process.env.REACT_APP_LST_API_DOMAIN + '/api/ResultsAndComments/SubmitResultAndCommentView?periodId=' + periodId + '&nodeId=' + nodeId , {
                method: "POST",
                headers: {
                    Accept: "text/plain",
                    "Content-Type": "application/json",
                    'Authorization': authorizationBearer,
                },
            });

        } catch (error) {
            if (process.env.NODE_ENV === 'development')
                console.log('There was an error', error);
            else
                console.log('There was an error');
            response = error
        }


        if (response?.ok) {
            return await response?.json();
        } else {
            if (process.env.NODE_ENV === 'development')
                console.log(`HTTP Response Code: ${response?.status}`)
            return { error: response }
        }
    },

    resetResultsAndCommentsView: async function (periodId, nodeId) {
        let response;

        try {
            response = await fetch(process.env.REACT_APP_LST_API_DOMAIN + '/api/ResultsAndComments/ResetResultsAndCommentsView?periodId=' + periodId + '&nodeId=' + nodeId, {
                method: "POST",
                headers: {
                    Accept: "text/plain",
                    "Content-Type": "application/json",
                    'Authorization': authorizationBearer,
                },
            });

        } catch (error) {
            if (process.env.NODE_ENV === 'development')
                console.log('There was an error', error);
            else
                console.log('There was an error');
            response = error
        }


        if (response?.ok) {
            return await response?.json();
        } else {
            if (process.env.NODE_ENV === 'development')
                console.log(`HTTP Response Code: ${response?.status}`)
            return { error: response }
        }
    },
    
    giveResultsAndCommentsValues: async function (nodeId, periodId) {
        let response;
        try {
            response = await fetch(process.env.REACT_APP_LST_API_DOMAIN + '/api/ResultsAndComments/GiveResultsAndCommentsValues/' + nodeId + '/' + periodId, {
                headers: headers
            });
        } catch (error) {
            if (process.env.NODE_ENV === 'development')
                console.log('There was an error', error);
            else
                console.log('There was an error, try again after sometime.');
            response = error
        }

        if (response?.ok) {
            return await response.json();
        } else {
            if (process.env.NODE_ENV === 'development')
                console.log(`HTTP Response Code: ${response?.status}`)
            return { error: response }
        }
    },
        
};